import { useState } from "react";

function FormButton({
  text,
  onClick,
  bgColor = "#295B24", // can be hex, rgb, or rgba
  textColor = "rgba(255,255,255,1)",
  hoverTextColor = "hover:text-white",
  className = "",
}) {
  const [hover, setHover] = useState(false);

  // Function to convert hex to rgba with custom alpha
  const hexToRgba = (hex, alpha = 0.6) => {
    let r = 0,
      g = 0,
      b = 0;
    if (hex[0] === "#") hex = hex.slice(1);

    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
      r = parseInt(hex[0] + hex[1], 16);
      g = parseInt(hex[2] + hex[3], 16);
      b = parseInt(hex[4] + hex[5], 16);
    }

    return `rgba(${r},${g},${b},${alpha})`;
  };

  // Determine background color
  const backgroundColor = bgColor.startsWith("#")
    ? hexToRgba(bgColor, hover ? 1 : 0.6) // full opacity on hover
    : bgColor;

  return (
    <button
      type="submit"
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ backgroundColor, color: textColor }}
      className={`FormButton w-full flex items-center justify-center gap-1 px-2 py-0 h-[56px] rounded-[15px] transition duration-300 whitespace-nowrap ${hoverTextColor} ${className}`}
    >
      <span className="text-21pt">{text}</span>
    </button>
  );
}

export default FormButton;
